import {TruckConfigurationDto} from '../../../../options/truck.types'
import {OrderDto} from '../../../types'

export const getOrderTruckMaxLoad = (order: OrderDto) => {
  return order.schedules[0].maxLoadSpaceSize || order.schedules[0].maxLoadSize
}

export const getDefaultTruckSize = (configuration: TruckConfigurationDto) => {
  if (configuration.isEnabled) {
    const truckTypes = configuration.truckTypes
    const defaultTruck = truckTypes.values.find((x) => x.number === truckTypes.default)!
    return defaultTruck.size
  }
  return configuration.defaultTruckSize
}
